import { useMutation } from '@tanstack/react-query';

import { toast } from '@hivebrite/design-system/Toast';

import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

export const usePostReportContent = () =>
  useMutation({
    mutationFn: ({ contentIdToReport }: { contentIdToReport: number | null }) =>
      axios.post(
        Routes.report_content_private_frontoffice_recommendations_path(),
        {
          content_id: contentIdToReport,
        },
      ),
    onSuccess: () => {
      toast.success(
        s__(
          'ContentRecommendation|Your report has been sent. Thanks for helping us improve recommendations.',
        ),
      );
    },
    onError: () => {
      toast.error(__('Failed to report content recommendation'));
    },
  });
